import { computed, ComputedRef } from 'vue'

import { useTeamSides } from '@desktop/views/Relation/composables'

import { useServeIncident } from '../useServeIncident'

export function useAssignPlayerOnPitch(): {
  overlayClass: ComputedRef<string>
} {
  // composables
  const { lastServeTeamSide, isReceptionVisible } = useServeIncident()
  const { currentFirstTeamSide } = useTeamSides()

  // computed
  const overlayClass = computed(() => {
    if (!isReceptionVisible.value || !lastServeTeamSide.value) {
      return ''
    }
    return lastServeTeamSide.value === currentFirstTeamSide.value
      ? '!w-1/2 mr-auto'
      : '!w-1/2 ml-auto'
  })

  return {
    overlayClass,
  }
}
